<mat-toolbar class="p0 mat-elevation-z1">
  <!-- <mat-progress-bar
    *ngIf="showLoadingBar"
    class="loading-bar"
    color="accent"
    mode="indeterminate"
  ></mat-progress-bar> -->
  <div
    fxFlex
    fxFill
    fxLayout="row"
     fxLayoutAlign="start center" 
  >
    <div
      fxFlex="1 0 auto"
      fxLayout="row"
      fxLayoutAlign="start center" 
    >
      <button
        mat-icon-button
        class="toggle-button-navbar"
        *ngIf="!noNav"
        (click)="toggleSidebarOpened()"
        fxHide.gt-md
      >
        <mat-icon>menu</mat-icon>
      </button>
      <div
        class="toolbar-separator"
        fxHide.gt-md
      ></div>
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        *ngIf="horizontalNav"
      >
        <div class="logo ml16">
          <img
            class="logo-icon"
            [src]="userData.pic ? userData.pic :'https://www.flaticon.com/svg/static/icons/svg/149/149071.svg'"
            alt="User logo"
          >
        </div>
      </div>
      <div class="px8 px-mat-16">
        <app-shortcuts [navigation]="navigation"></app-shortcuts>
      </div>
    </div>
    <div fxLayout="row"  fxLayoutAlign="center center" >
      <button
        mat-button
        [matMenuTriggerFor]="userMenu"
        class="user-button"
      >
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <img
            class="avatar m8"
            [src]="userData?.pic ? userData.pic :'https://www.flaticon.com/svg/static/icons/svg/149/149071.svg'"
             alt="User logo"
            >
          <span
            class="username mr12"
            fxShow.gt-sm
          >{{userData?.name}}</span>
          <mat-icon
            class="s16"
            fxHide.xs
          >keyboard_arrow_down</mat-icon>
        </div>
      </button>
      <mat-menu
        #userMenu="matMenu"
        [overlapTrigger]="false"
      >
        <button
          mat-menu-item
          (click)='profile()'
        >
          <mat-icon>account_circle</mat-icon>
          <span>My Profile</span>
        </button>
        <button
          mat-menu-item
          class=""
          (click)='logout()'
        >
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
      <div class="toolbar-separator"></div>
      <button
        mat-button
        (click)="openThemePanel()"
      >
        <mat-icon>settings</mat-icon>
      </button>
      <div class="toolbar-separator"></div>
      <button
        mat-button
        appNkMatSidenavToggler="quick-panel"
        aria-label="Toggle quick panel"
      >
        <mat-icon class="icon">format_list_bulleted</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
